{
    "translation": {
        "welcome": "Bienvenido",
        "home": "Inicio",
        "find_pro": "Buscar un Profesional",
        "admin": "Admin",
        "my_space": "Mi Espacio",
        "login": "Iniciar Sesión",
        "logout": "Cerrar Sesión",
        "search_placeholder": "Peluquero, Barbero, Manicura...",
        "hero_title": "Reserva tu cita de belleza",
        "hero_subtitle": "Encuentra los mejores profesionales cerca de ti.",
        "search_btn": "Buscar",
        "popular_services": "Servicios Populares",
        "footer_rights": "Todos los derechos reservados.",
        "legal_mentions": "Menciones Legales",
        "cgp": "Condiciones Generales de Prestación",
        "feature_search_title": "Buscar",
        "feature_search_desc": "Encuentra los mejores salones y expertos cerca de ti",
        "feature_book_title": "Reservar",
        "feature_book_desc": "Elige tu horario ideal en segundos",
        "feature_enjoy_title": "Disfrutar",
        "feature_enjoy_desc": "Vive una experiencia de belleza única y relajante",
        "featured_pros_title": "Profesionales Destacados",
        "reviews_count": "reseñas",
        "client_space": "ÁREA DE CLIENTE",
        "my_bookings": "Mis Reservas",
        "explore_map": "Explorar Mapa",
        "edit_photo": "Editar Foto",
        "photo_updated": "¡Foto de perfil actualizada!",
        "error_upload": "Error al subir la foto."
    }
}